import * as yup from 'yup'
import { COUNTRIES } from 'constants/countriesStates'

export const CompanyInformationSchema = yup
  .object({
    entityType: yup.string().required('Please select an entity type.'),
    ein: yup.string().required('Please enter a EIN number.').length(9, 'Must be 9 digits.'),
    address: yup.string().required('Please enter billing address.'),
    addressLine2: yup.string().notRequired(),
    countryCode: yup.string().required('Please select country.'),
    city: yup.string().required('Please enter city.'),
    zipcode: yup.string().when('countryCode', {
      is: val => val === COUNTRIES[1].code, // 'CA'
      then: yup
        .string()
        .required('Please enter postal code.')
        .min(6, 'Must be 6 or 7 characters.')
        .max(7, 'Must be 6 or 7 characters.')
        .matches(/^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/, 'Invalid postal code.'),
      otherwise: yup.string().required('please enter ZIP code.').length(5, 'Must be 5 digits.'),
    }),
    stateCode: yup.string().required('Please enter state.'),
    contactEmail: yup
      .string()
      .trim()
      .email('Please enter a valid email.')
      .required('Please enter email.'),
    contactPhone: yup
      .string()
      .required('Please enter phone number.')
      .length(10, 'Please enter a valid phone number.'),
  })
  .required()

export type TCompanyInformationSchema = yup.InferType<typeof CompanyInformationSchema>
